import { Box, Button, Step, StepLabel, Stepper, Typography } from '@mui/material';
import { useState, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../../../services/auth/AuthContext';

import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import fetchApplicationsService from '../../../../../services/api/fetchApplications';
import { QontoConnector, QontoStepIconRoot } from './QontoConnector';

function QontoStepIcon({
    content,
    active,
    completed,
    className,
    onClick,
    bgColor,
    disabled,
}) {
	return (
		<QontoStepIconRoot ownerState={{ active }} className={className}>
			<Button
				variant={(completed || active) ? 'contained' : 'outlined'}
				color={bgColor}
				onClick={onClick}
				disabled={disabled}
				sx={(({ palette }) => ({
					borderRadius: '50%',
					width: '2rem',
					height: '2rem',
					minWidth: 'auto',
					outline: active ? `3px solid ${palette[bgColor].main}` : 'none',
					outlineOffset: '2px',
					...(disabled && (completed || active) && {
						'&.Mui-disabled': {
							backgroundColor: palette[bgColor].main,
							color: 'black',
						},
					}),
				}))}
			>
				{content}
			</Button>
		</QontoStepIconRoot>
	);
}

export default function LoanStatusTabs({
    showStatuses,
    currentStatusCode,
    setCurrentStatusCode,
    loanType,
    tabColor = 'warning',
    current_application_status = 'pending',
    isClickable = true,
}) {
    const { i18n } = useTranslation();
    const [countJson, setCountJson] = useState([]);

    const [searchParams] = useSearchParams();
    const source = searchParams.get('source') ?? 'all';
    const campaign = searchParams.get('campaign') ?? 'all';
    const state = searchParams.get('state') ?? 'all';
    const priority = searchParams.get('priority') ?? 'all';
    const dispositions = searchParams.get('dispositions') ?? 'all';
	const rejectionReason = searchParams.get('rejectionReason') ?? 'all';

    const { setIsAuthenticated } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchLoanApplicationsCount = async () => {
            try {
                const response = await fetchApplicationsService.getApplicationCountForReferralByLoanType(
                    loanType,
                    {
                        source: source,
                        campaign: campaign,
                        state: state,
                        priority: priority,
                        dispositions: dispositions,
                        rejection_reason: rejectionReason,
                        current_application_status: current_application_status
                    },
                    setIsAuthenticated,
                    navigate
                );
                let count_json = {};
                Object.keys(showStatuses).forEach((key) => {
                    count_json[key] = 0;
                });
    
                if (current_application_status === 'unserviceable') {
                    const singleStatusCode = Object.keys(showStatuses)[0];
                    if (response.count) {
                        const totalCount = Object.values(response.count).reduce(
                            (sum, count) => sum + (Number(count) || 0), 0
                        );
                        count_json[singleStatusCode] = totalCount;
                    }
                } else {
                    Object.assign(count_json, response.count);
                }
                setCountJson(count_json);
            } catch (error) {
                console.log(error);
            } finally {}
        };
        fetchLoanApplicationsCount();
    }, [loanType, navigate, setIsAuthenticated, showStatuses, source, campaign, state, priority, dispositions, rejectionReason, current_application_status]);

    return (
        <Box>
            <Stepper
                alternativeLabel
                activeStep={showStatuses[currentStatusCode]?.order ? showStatuses[currentStatusCode].order - 1 : 0}
                connector={<QontoConnector />}
                sx={{
                    pt: 2,
                    overflowX: 'auto',
                }}
            >
                {Object.keys(showStatuses).map((statusCode) => (
                    <Step key={statusCode}>
                        <StepLabel
                            StepIconComponent={QontoStepIcon}
                            StepIconProps={{
                                content: (
                                    <Typography>
                                        {countJson[statusCode]}
                                    </Typography>
                                ),
                                bgColor: tabColor,
                                onClick: isClickable ? () => setCurrentStatusCode(statusCode) : null,
                                disabled: countJson[statusCode] === 0,
                            }}
                        >
                            {showStatuses[statusCode].header[i18n.language]}
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>
        </Box>
    );
}
